function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M8.294 18.125c0 .481-.37.875-.823.875H5.824c-.421 0-.77-.34-.818-.773L5 18.125V5.875C5 5.394 5.37 5 5.824 5H7.47c.453 0 .823.394.823.875s-.37.875-.823.875h-.824v10.5h.824c.453 0 .823.394.823.875zM19 12c0 .484-.369.875-.823.875h-6.589l1.483 2.1a.91.91 0 01-.165 1.225.792.792 0 01-1.153-.175l-2.47-3.5a.915.915 0 01-.015-1.028l2.317-3.5a.793.793 0 011.147-.213.91.91 0 01.2 1.22l-1.408 2.124a.798.798 0 01.064-.003h6.589c.454 0 .823.391.823.875z",
  fill: "#fff"
});

function SvgSignOut(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none"
  }, props), _ref);
}

export default SvgSignOut;